"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>ChildrenLineItem
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_ChildAgeSelect_cjs_namespaceObject = require("./ChildAgeSelect.cjs");
var external_ChildAgeSelect_cjs_default = /*#__PURE__*/ __webpack_require__.n(external_ChildAgeSelect_cjs_namespaceObject);
const external_TravelerLineItem_cjs_namespaceObject = require("./TravelerLineItem.cjs");
const ChildrenLineItem_ChildrenLineItem = ({ ages, ageSelectEnabled, count, max, isHotel, onAgeChange, onChange, subLabel })=>{
    const selects = Array(count).fill(0);
    const sublabel = ageSelectEnabled ? void 0 : subLabel;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex w-full flex-col",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_TravelerLineItem_cjs_namespaceObject.TravelerLineItem, {
                label: "Children",
                subLabel: sublabel,
                min: 0,
                max: max,
                count: count,
                onChange: onChange
            }),
            ageSelectEnabled ? selects.map((_value, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_react_default().Fragment, {
                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ChildAgeSelect_cjs_default(), {
                        index: index,
                        isHotel: isHotel,
                        value: ages?.[index],
                        onChange: onAgeChange
                    })
                }, `container-${index}`)) : null
        ]
    });
};
const ChildrenLineItem = /*#__PURE__*/ (0, external_react_namespaceObject.memo)(ChildrenLineItem_ChildrenLineItem);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
